import { useFormik } from "formik";
import * as Yup from "yup";

const useNotificationSubscription = () => {
    // Initial Values
    const initialValues = {
        email: "",
    };

    // Validation
    const validationSchema = Yup.object({
        email: Yup.string()
            .required("Email address is required")
            .email("Invalid email address format"),
    });

    /**
     * NOTE:
     * The funcionality is not available right now
     * Should be updated with calling the End point when made available
     */
    // Handle Save
    const handleSave = (values) => {
        console.log(`Sunbmiting user ${values.email} to noifications`);
        return true;
    };

    // Formik
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: handleSave,
    });

    // Return values
    return {
        formik,
    };
};

export default useNotificationSubscription;
